module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "overflow": "hidden",
      "height": "100%"
    },
    attrs: {
      "id": "app"
    }
  }, [_c('app-head'), _vm._v(" "), _c('app-aside', {
    ref: "appAside",
    class: _vm.hideOrshow,
    attrs: {
      "currentNodeName": _vm.tab_cur_name
    },
    on: {
      "toggleMenu": _vm.toggleMenu,
      "passLinkVal": _vm.getLinkVal,
      "showJump": _vm.showJump,
      "showAd": _vm.showAd,
      "showEnvironment": _vm.showEnvironment
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app-content",
    class: {
      active: _vm.tab_cur_name != -1
    }
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('div', {
    staticClass: "tab-head"
  }, [_c('el-tabs', {
    attrs: {
      "id": "head-tabs",
      "type": "card"
    },
    on: {
      "tab-click": _vm.tab_click,
      "tab-remove": _vm.tab_remove
    },
    nativeOn: {
      "contextmenu": function($event) {
        _vm.contextmenu($event)
      }
    },
    model: {
      value: (_vm.tab_cur_name),
      callback: function($$v) {
        _vm.tab_cur_name = $$v
      },
      expression: "tab_cur_name"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "首页",
      "name": "-1"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    staticClass: "name_1",
    attrs: {
      "label": "待办事项",
      "name": "-2"
    }
  }), _vm._v(" "), _vm._l((_vm.tab_list), function(temp) {
    return _c('el-tab-pane', {
      key: temp.name,
      attrs: {
        "label": temp.label,
        "name": temp.name,
        "closable": ""
      }
    })
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "mainRouterView"
  }, [_c('router-view', {
    ref: "routeComp",
    attrs: {
      "hide_menu": _vm.hide_menu
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "toggle-menu",
    attrs: {
      "title": "隐藏侧边栏"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('div', {
    staticClass: "toggle-menu-btn"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hide_menu),
      expression: "!hide_menu"
    }],
    staticClass: "el-icon-arrow-left",
    staticStyle: {
      "margin-left": "-2px"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hide_menu),
      expression: "hide_menu"
    }],
    staticClass: "el-icon-arrow-right",
    staticStyle: {
      "margin-left": "-2px"
    }
  })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('el-menu', {
    staticClass: "el-menu-context",
    style: ({
      top: _vm.clientY,
      left: _vm.clientX,
      width: '150px',
      display: (_vm.showContextmenu ? 'block' : 'none')
    })
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.closeCur()
      }
    },
    slot: "title"
  }, [_vm._v("关闭当前")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.closeOth()
      }
    },
    slot: "title"
  }, [_vm._v("关闭其他")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "4"
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.closeRight()
      }
    },
    slot: "title"
  }, [_vm._v("关闭到右侧")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "5"
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.closeLeft()
      }
    },
    slot: "title"
  }, [_vm._v("关闭到左侧")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.closeAll()
      }
    },
    slot: "title"
  }, [_vm._v("关闭所有")])])], 1), _vm._v(" "), (_vm.imgShow) ? _c('div', {
    staticClass: "back"
  }, [_c('img', {
    attrs: {
      "src": this.img,
      "alt": "造价神器了解一下"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://zaojia.hymake.cn",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "del",
    on: {
      "click": function($event) {
        _vm.imgShow = false
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showDialog) ? _c('div', {
    staticClass: "dialog"
  }, [_c('div', {
    staticClass: "cont cont1"
  }, [_c('img', {
    staticClass: "img",
    staticStyle: {
      "z-index": "10"
    },
    attrs: {
      "src": _vm.del,
      "alt": "关闭"
    },
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "hidden",
      "height": "510px",
      "text-align": "center",
      "position": "relative"
    }
  }, [_c('img', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "src": _vm.file
    },
    on: {
      "click": function($event) {
        _vm.showDialogBid = true
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.showAdDialog) ? _c('div', {
    staticClass: "dialog"
  }, [_c('div', {
    staticClass: "cont",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.del,
      "alt": "关闭"
    },
    on: {
      "click": function($event) {
        _vm.showAdDialog = false
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#1cf62f",
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v("信用加分了解一下？")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#396eff",
      "font-size": "20px"
    }
  }, [_vm._v("使用海迈电子档案平台，就有信用加分啦~~欢迎马上加入第四批省站试点项目名单。")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "5px 20px",
      "text-align": "left"
    }
  }, [_c('img', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "src": _vm.luo,
      "title": "扫一扫了解详细政策及软件介绍",
      "width": "100px"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px",
      "color": "#333"
    }
  }, [_vm._v("扫一扫了解详细政策及软件介绍（请备注单位名称及姓名）")])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticStyle: {
      "float": "right",
      "font-size": "14px"
    }
  }, [_c('a', {
    staticStyle: {
      "font-size": "14px",
      "color": "#41464a"
    },
    attrs: {
      "href": "http://www.hymake.com",
      "target": "new"
    }
  }, [_vm._v("@厦门海迈科技股份有限公司")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "right",
      "color": "red"
    }
  }, [_vm._v("加分热线：181 5929 5756 罗工 "), _c('br'), _vm._v("  0592-5399945 龚工 ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "line-height": "30px",
      "text-align": "left",
      "margin": "0 20px",
      "border": "1px solid #666",
      "padding": "5px"
    }
  }, [_vm._v("相关政策文件："), _c('br'), _vm._v("关于再次征求《建筑施工企业通常行为评价标准（2018年版第二次征求意见稿）》意见的通知 "), _c('b', {
    staticStyle: {
      "color": "red",
      "font-size": "14px"
    }
  }, [_vm._v("[闽建办筑函〔2018〕28号]")]), _vm._v(" "), _c('br'), _vm._v("4.5项目电子档案管理 "), _c('br'), _vm._v("按照工程类别（房建总承包、市政总承包），分别在房建总承包、市政总承包两类序列中加分。（满分1分）")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56f77738","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App_son.vue
// module id = 591
// module chunks = 143